/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect, useState } from "react";
import { useCurrentEditor } from "@tiptap/react";
import { getProductData } from "../../../services/Product/ProductService/productService";
import { useMutation } from "@tanstack/react-query";
import { updateResource } from "../../../services/ReactQuery/reactQueryService";
import { useCase } from "../../../provider/CaseProvider";
import { createPortal } from "react-dom";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";
import ButtonLoading from "../../Button/ButtonLoading";
import Grid from "@mui/material/Grid";
import LegalbirdTipTapEditorProvider from "../../LbEditor/LegalbirdTipTapEditorProvider";
import LegalbirdTipTapEditor from "../../LbEditor/LegalbirdTipTapEditor";
import { useDrawer } from "../../../provider/DrawerProvider";

export default function CaseDescriptionEdit(props: CaseDescriptionEditInnerProps) {
  return (
    <LegalbirdTipTapEditorProvider>
      <CaseDescriptionEditInner {...props} />
    </LegalbirdTipTapEditorProvider>
  );
}

type CaseDescriptionEditInnerProps = {
  handleClose?: () => void;
};

function CaseDescriptionEditInner({ handleClose }: CaseDescriptionEditInnerProps) {
  const { product, refreshCase } = useCase();
  const { editor } = useCurrentEditor();
  const [isLoading, setIsLoading] = useState(false);
  const updateMutation = useMutation({
    mutationFn: updateResource
  });
  const { drawerActionsNode } = useDrawer();

  useEffect(() => {
    editor?.commands.setContent(product?.caseDescription || "");
  }, []);

  if (
    !product ||
    !product.caseDescription ||
    !getProductData(product.productClassName, "showCaseDescription")({ product }) ||
    !drawerActionsNode
  ) {
    return null;
  }

  const saveCaseDescription = async (content: string | null) => {
    setIsLoading(true);
    await updateMutation.mutateAsync({
      id: product.id,
      uri: getProductData(product.productClassName, "apiUri"),
      data: {
        caseDescription: content,
      },
    });
    await refreshCase();
    handleClose?.();
    setIsLoading(false);
  };

  return (
    <>
      <Grid container>
        <Grid size={12}>
          <LegalbirdTipTapEditor />
        </Grid>
      </Grid>
      {createPortal(
        <Grid container sx={{ width: "100%" }}>
          <Grid size={3} sx={{ display: { xs: "none", md: "block" } }} />
          <Grid size={{ xs: 12, md: 6 }} sx={{ marginTop: 6 }}>
            <ButtonLoading
              variant={"contained"}
              onClick={() => saveCaseDescription(getEditorHtml(editor))}
              isLoading={isLoading}
            >
              Speichern
            </ButtonLoading>
          </Grid>
        </Grid>,
        drawerActionsNode
      )}
    </>
  );
}
